import * as React from 'react';
import { Dialog, DialogType, DialogFooter } from '@fluentui/react/lib/Dialog';
import { PrimaryButton, DefaultButton } from '@fluentui/react/lib/Button';
import { ContextualMenu } from '@fluentui/react/lib/ContextualMenu';
import { IButtonStyles } from 'office-ui-fabric-react';
import SmartActionButton from './SmartActionButton';
import { Stack } from '@fluentui/react';

export const stylesButtonAI : IButtonStyles= {
  root: {
    backgroundColor: '#f3f3f3',
    borderColor: '#d0d0d0',
    color: '#333333',
    padding: '10px 18px',
    fontSize: 16,
    fontWeight: 600,
    borderRadius: 6,
    transition: 'all 0.3s ease',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    userSelect: 'none',
  },
  rootHovered: {
    backgroundColor: '#e0e0e0',
    borderColor: '#c0c0c0',
    color: '#1a1a1a',
    boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
    transform: 'translateY(-2px)',
  },
  rootPressed: {
    backgroundColor: '#d6d6d6',
    borderColor: '#a0a0a0',
    color: '#000000',
    boxShadow: 'inset 0 2px 5px rgba(0,0,0,0.2)',
    transform: 'translateY(0)',
  },
  icon: {
    color: '#333333',
    transition: 'transform 0.3s ease',
  },
};

const dragOptions = {
  moveMenuItemText: 'Move',
  closeMenuItemText: 'Close',
  menu: ContextualMenu,
};
// const modalPropsStyles = { main: { minWidth: 900 } };

interface IDialogTemplate {
  showDialog: boolean;
  toggleShowDialog: () => void;
  title: string;
  children: JSX.Element;
  onAccept: () => void;
  onCancel: () => void;
  acceptText: string;
  cancelText: string;
  minWidth?: number;
  maxWidth?: number;
  validateAccept?: () => boolean;
  hideCancelButton?: boolean;
  hideAcceptButton?: boolean;

  // Nuevo botón opcional
  onExtraButtonClick?: () => void;
  extraButtonText?: string;
  extraButtonIcon?: JSX.Element;
  hideExtraButton?: boolean;
  extraButtonDisabled?: boolean; 
  extraButtonLoading?: boolean; 
}

const DialogTemplate = (props: IDialogTemplate) => {
  const modalProps = {
    isBlocking: true,
    // styles: modalPropsStyles,
    dragOptions: dragOptions,
  };

  const dialogContentProps = React.useMemo(() => {
    return {
      type: DialogType.normal,
      title: props.title,
      className: 'dialog-template',
    };
  }, [props]);

  return (
      <>
        <Dialog
            hidden={!props.showDialog}
            onDismiss={props.toggleShowDialog}
            dialogContentProps={dialogContentProps}
            modalProps={{
              ...modalProps,
              styles: {
                main: {
                  display: 'flex',
                  flexDirection: 'column',
                  maxHeight: '80vh',
                },
                scrollableContent: {
                  display: 'flex',
                  flexDirection: 'column',
                  flexGrow: 1,
                  overflowY: 'auto',
                },
              },
            }}
            minWidth={props.minWidth ? props.minWidth : 400}
            // className="animation-height"
        >
          {props.children}
          <DialogFooter>
            {!props.hideExtraButton && props.onExtraButtonClick && props.extraButtonText && (
              <SmartActionButton
                disabled={props.extraButtonDisabled}
                onClick={props.onExtraButtonClick}
                text={props.extraButtonText}
                icon={props.extraButtonIcon}
                loading={props.extraButtonLoading}
              />
            )}
            {!props.hideAcceptButton && (
                <PrimaryButton
                    disabled={props.validateAccept ? props.validateAccept() : false}
                    onClick={props.onAccept}
                    text={props.acceptText}
                />
            )}
            {!props.hideCancelButton && <DefaultButton onClick={props.onCancel} text={props.cancelText} />}
          </DialogFooter>
        </Dialog>
      </>
  );
};

export default DialogTemplate;
